<!-- <p>power-catalog-element works!</p> -->

<!--esta es la linea donde se colocan las opciones de la empresa -->
<div class="table table-responsive smart-table">
  <angular2-smart-table 
    [settings]="element_settings" 
    [source]="powerCatalogData| async" 
    (createConfirm)="add_element($event)" 
    (deleteConfirm)="delete_element($event)" 
    (editConfirm)="edit_element($event)" 
    style="width: 60px; text-align: left;">
  </angular2-smart-table>
</div>

<!-- <div>



    <div *ngIf="(powerCatalogData | async) as powerCatalogData; else noData">
        <h3>Power</h3>
        <ul>
          <li *ngFor="let item of powerCatalogData">
            id: {{ item.id }} | name: {{ item.name }} | created_at:{{ item.created_at }} | short_name: {{ item.short_name }} | description: {{ item.description }}
          </li>
        </ul>
    </div>
      
    <ng-template #noData>
        <p>No power {{url_path}} available.</p>
    </ng-template>
      

</div> -->
